import { useQuery } from "@tanstack/react-query";
import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { useApi } from "../../shared/api/index";

export const useFetchSeason = (params = {}) => {
  const { fetchData } = useApi();
  const { organizationId, sport, seasonId } = useParams();
  let URL = `${sport}/o/${organizationId}/seasons/${seasonId}`;
  if (!isEmpty(params)) {
    URL += `?${new URLSearchParams(params)?.toString()}`;
  }

  return useQuery({
    queryKey: ["seasons", sport, organizationId, seasonId, JSON.stringify(params)],
    queryFn: async () => {
      return await fetchData({
        url: URL,
      });
    },
  });
};
